<template>
  <v-dialog v-model="show" max-width="500px" :persistent="loading">
    <v-card>
      <dialog-title
        v-model="show"
        title="Import Tenant Users"
        :disabled="loading"
      ></dialog-title>
      <v-alert rounded="0" type="error" border="left" v-if="errors">
        <p>The following errors were found in the uploaded file.</p>
        <ul>
          <li class="text-body-2" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </li>
        </ul>
      </v-alert>
      <v-card-text>
        <ValidationObserver
          ref="observer"
          @submit.prevent="onSubmit"
          tag="form"
        >
          <v-row>
            <v-col cols="12">
              <p class="text-body-1">
                Use the form below to import tenant users.
                <strong color="error--text"
                  >Expect long waits for large files.</strong
                >
              </p>
            </v-col>

            <v-col cols="12">
              <ValidationProvider
                v-slot="{ errors, classes }"
                name="file"
                vid="file"
                rules="required|ext:csv"
              >
                <v-file-input
                  v-model="file"
                  label="Import File"
                  outlined
                  prepend-icon=""
                  :error="errors.length > 0"
                  :error-messages="errors[0]"
                  :class="classes"
                  prepend-inner-icon="$file"
                  persistent-hint
                  hint="WARNING -- If an existing user is found it's tenant permissions and
                password will be updated."
                ></v-file-input>
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="removeMissing"
                color="error"
                label="Remove users who are not included."
              ></v-checkbox>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn
                :disabled="loading"
                text
                color="primary"
                @click="show = false"
              >
                Cancel
              </v-btn>
              <v-btn
                :loading="loading"
                color="red darken-2 white--text"
                @click.prevent="onSubmit"
              >
                Import
              </v-btn>
            </v-col>
          </v-row>
        </ValidationObserver>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showConfirm" max-width="400px">
      <v-card>
        <dialog-title
          v-model="showConfirm"
          title="Confirm Remove"
          :disabled="loading"
        ></dialog-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <p class="text-body-1">
                Current selection will remove all tenant users who are not
                included in the imported fill. <br /><br />
                Are you sure?
              </p>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn
                :disabled="loading"
                text
                color="primary"
                @click="showConfirm = false"
              >
                Cancel
              </v-btn>
              <v-btn
                :loading="loading"
                color="red darken-1"
                dark
                @click="
                  confirmed = true;
                  showConfirm = false;
                  onSubmit();
                "
              >
                Yes, remove users
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import DialogTitle from "../../components/DialogTitle.vue";

import userService from "../../services/userService.js";

export default {
  name: "TenantUsersImport",
  components: { DialogTitle },
  data: () => ({
    show: false,
    file: null,
    pendingStateChanges: 0,
    errors: null,
    confirmed: false,
    removeMissing: false,
    showConfirm: false,
  }),
  computed: {
    tenantId() {
      return this.$store.state.tenantId;
    },
    loading() {
      return this.pendingStateChanges > 0;
    },
  },
  methods: {
    open() {
      this.file = null;
      this.errors = null;
      this.replaceExisting = false;
      this.confirmed = false;
      this.$refs.observer?.reset();
      this.show = true;
    },
    async onSubmit() {
      this.errors = null;
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      if (this.removeMissing && !this.confirmed) {
        this.showConfirm = true;
        return;
      }

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("tenantId", this.tenantId);
      formData.append("removeMissing", this.removeMissing);

      this.pendingStateChanges++;

      userService
        .importTenantUsers({ tenantId: this.tenantId, formData })
        .then(
          () => {
            this.show = false;
            this.$store.dispatch(
              "notifications/success",
              `Successfully imported users.`
            );
            this.$emit("reload");
          },
          (err) => {
            if (err.statusCode === 400) {
              this.errors = [];

              let i = 0;
              for (let key in err.result) {
                var recordNumber = key.match(/\[(.*)\]/).pop();
                this.errors.push(
                  `Row ${+recordNumber + 1} - "${key.split(".")[1]}": ${
                    err.result[key][0]
                  }`
                );
                i++;

                if (i === 10) break;
              }
            } else {
              console.warn(err);
              this.$store.dispatch(
                "notifications/error",
                `An unexpected error occurred while trying to import users. Please try again later.`
              );
            }
          }
        )
        .finally(() => this.pendingStateChanges--);
    },
  },
};
</script>
